<template>
  <div>
    <div class="row px-0 px-md-3 px-sm-0">
      <div class="col">
        <total-amount-adjustment-view
          :amount="adjustmentSummary.automaticAdjustmentAmount | price"
          class="px-3"
          has-border
          icon="fa fa-dollar-sign"
          icon-color="#2db782"
          :service-total="adjustmentSummary.automaticAdjustmentCount"
          title="Automáticos"
        />
        <hr class="d-block d-md-none d-sm-block" />
      </div>
      <div
        v-if="canShowManualAdjustments"
        class="col corner-line mt-3 mt-md-0 mt-sm-3"
      >
        <total-amount-adjustment-view
          :amount="adjustmentSummary.manualAdjustmentAmount | price"
          class="px-3"
          has-border
          icon="fa fa-dollar-sign"
          icon-color="#f8b538"
          :service-total="adjustmentSummary.manualAdjustmentCount"
          title="Manuales"
        />
        <hr class="d-block d-md-none d-sm-block" />
      </div>
      <div class="col mt-3 mt-md-0 mt-sm-3">
        <total-amount-adjustment-view
          v-if="canShowTotalAdjustment"
          :amount="adjustmentSummary.totalAdjustmentAmount | price"
          class="px-3"
          icon="fa fa-dollar-sign"
          icon-color="#b354c4"
          :objection-total="adjustmentSummary.totalObjectionCount"
          :service-total="adjustmentSummary.totalAdjustmentCount"
          :show-objection="true"
          title="Total"
        />
        <template v-else>
          <div class="row">
            <div class="col">
              <div class="d-flex">
                <icon-view
                  icon="fa fa-dollar-sign"
                  icon-background="#b354c4"
                  icon-color="#fff"
                  variant="custom-icon"
                  width="w-auto"
                />
                <div class="color-black font-weight-bold font-20">Total</div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="d-flex flex-column">
                <div class="color-black font-weight-bold font-16">
                  No se presenta el total de ajuste ya que se encuentra en
                  {{ getBillStatusDescription }}.
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <hr />
    <div class="mt-4">
      <filter-manager
        ref="filterRef"
        v-model="filterModel"
        class="mb-4 p-4"
        :display-advanced="false"
        :filters="filterManagerAdjustmentConfig"
        search-container-class="d-flex justify-content-end align-items-end"
        search-text=""
        @adjustmentType="onChangeAdjustmentType"
      >
        <div class="col-12 col-md-2 d-flex align-items-end">
          <action-button
            class="search mb-2 col-12"
            i="fas fa-search"
            :style="{ width: isMobile ? '100%' : '' }"
            text="Buscar"
            variant="success"
            @click="onSearchHandler"
          />
        </div>
      </filter-manager>
    </div>
    <custom-result-not-found v-if="results.length == 0" />
    <div v-else>
      <icon-view
        class="mt-5 mb-3 mt-md-0 mt-sm-5"
        :gradient="true"
        icon="fas fa-file-alt"
        icon-background="white"
        icon-color="#ff7058"
        icon-size="16px"
        title="Detalle de Ajuste"
      />
      <ResultRowAdjustment
        :key="keyResultRow"
        :bill-id="billId"
        :bill-status="billStatus"
        :data="results"
        @reload-info="updateInfo()"
      />

      <pagination
        v-if="pagination.totalItemCount > 10"
        :data="pagination"
        show-text
        @page-size-change="changePageSize"
        @pagination-go-page="goToPageHandler"
      />
    </div>
  </div>
</template>

<script>
import FilterManager from 'FilterManager';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import TotalAmountAdjustmentView from './components/TotalAmountAdjustmentView.vue';
import ResultRowAdjustment from './components/ResultRow.vue';
import billingStatus from '@/utils/constants/billingStatus';
import { name as appModuleName } from '@/store/modules/app';
import { mapGetters } from 'vuex';
import {
  getAdjustmentsummary as _getAdjustmentsummary,
  getAdjustmentReasonlist as _getAdjustmentReasonlist,
  getAllAdjustment as _getAllAdjustment,
} from '@/services/provider/billing-history.api';
import IconView from 'icon-view';
import Pagination from 'pagination';

export default {
  name: 'BillingAdjustmentDetail',
  components: {
    FilterManager,
    ActionButton,
    TotalAmountAdjustmentView,
    ResultRowAdjustment,
    IconView,
    Pagination,
    CustomResultNotFound,
  },
  data: () => ({
    originalAdjustmentList: [],
    adjustmentList: [],
    keyResultRow: 1,
    pagination: {
      pageIndex: 1,
      pageSize: 10,
      totalItemCount: 0,
      showPageSizeOptions: false,
      pageSizeOptions: [5, 10, 25, 30],
    },
    adjustmentSummary: {
      automaticAdjustmentAmount: 0,
      automaticAdjustmentCount: 0,
      manualAdjustmentAmount: 0,
      manualAdjustmentCount: 0,
      totalAdjustmentAmount: 0,
      totalAdjustmentCount: 0,
    },
    filterModel: {
      adjustmentType: null,
      adjustment: null,
      objected: null,
      status: null,
      sie: null,
      contract: null,
    },
    results: [],
  }),
  props: {
    billId: {
      type: Number,
      default: () => 0,
    },
    billStatus: {
      type: Number,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    canShowManualAdjustments() {
      if (this.billStatus == billingStatus.EnProcesoIntervencion) {
        return this.userHasPermissions(
          'rempro.providers.billinghistory.showmanualadjustments.interventionprocess'
        );
      }
      return true;
    },
    canShowTotalAdjustment() {
      if (this.billStatus == billingStatus.EnProcesoIntervencion) {
        return this.userHasPermissions(
          'rempro.providers.billinghistory.showadjustmentandtotaloninterventionprocess'
        );
      }
      if (this.billStatus == billingStatus.EnProcesoIntervencionObjetada) {
        return this.userHasPermissions(
          'rempro.providers.billinghistory.showadjustmentandtotalonobjectedinterventionprocess'
        );
      }

      return true;
    },
    getBillStatusDescription() {
      if (this.billStatus == billingStatus.EnProcesoIntervencion) {
        return 'Proceso de Intervención';
      }
      if (this.billStatus == billingStatus.EnProcesoIntervencionObjetada) {
        return 'Proceso de Intervención Objetada';
      }
      return '';
    },
    filterManagerAdjustmentConfig() {
      return [
        {
          name: 'adjustmentType',
          label: 'Tipo:',
          component: 'CustomDropDown',
          options: this.adjustmentTypes,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          value: this.filterModel.adjustmentType,
        },
        {
          name: 'adjustment',
          label: 'Ajuste:',
          component: 'CustomDropDown',
          options: this.adjustmentList,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          value: this.filterModel.adjustment,
        },
        {
          name: 'objected',
          label: 'Objetado:',
          component: 'CustomDropDown',
          options: this.adjustmentObjectedTypes,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          value: this.filterModel.objected,
        },
        {
          name: 'status',
          label: 'Estatus:',
          component: 'CustomDropDown',
          options: this.adjustmentStatusTypes,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
          value: this.filterModel.status,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          class: 'col-12 col-md-3',
          label: 'Número de SIE:',
          placeholder: 'Escriba número de SIE',
          value: this.filterModel.sie,
        },
        {
          name: 'contract',
          component: 'CustomInput',
          class: 'col-12 col-md-3',
          label: 'Número de Contrato:',
          placeholder: 'Escriba número de Contrato',
          value: this.filterModel.contract,
        },
        {
          name: 'contractSeparator',
          component: 'div',
          class: 'col-12 col-md-4',
        },
      ];
    },
    adjustmentTypes() {
      return [
        { id: 0, name: 'Automático', value: false },
        { id: 1, name: 'Manual', value: true },
      ];
    },
    adjustmentObjectedTypes() {
      return [
        { id: 1, name: 'Sí', value: true },
        { id: 0, name: 'No', value: false },
      ];
    },
    adjustmentStatusTypes() {
      return [
        { id: 1, name: 'Sometida' },
        { id: 2, name: 'Aceptada' },
        { id: 3, name: 'Rechazada' },
      ];
    },
  },
  async mounted() {
    await this.getAdjustmentSummary();
    await this.getBillingAdjustmentList();
    await this.getAllAdjustment();
  },
  methods: {
    async updateInfo() {
      await this.getAdjustmentSummary();
      await this.getAllAdjustment();
      this.keyResultRow = this.keyResultRow * -1;
      this.$emit('reload-quantity');
    },
    onChangeAdjustmentType() {
      this.filterModel.adjustment = null;
      this.loadAdjustmentList();
    },
    loadAdjustmentList() {
      let adjustments = this.originalAdjustmentList;
      let adjustmentType = this.filterModel.adjustmentType;
      if (adjustmentType == null) {
        this.adjustmentList = this.originalAdjustmentList;
        return;
      }

      this.adjustmentList = adjustments.filter((x) =>
        adjustmentType.id == 1
          ? x.wasManuallyAddedFlag
          : !x.wasManuallyAddedFlag
      );
    },
    async getBillingAdjustmentList() {
      const { data } = await _getAdjustmentReasonlist(this.billId);
      this.originalAdjustmentList = data;
      this.loadAdjustmentList();
    },
    async getAllAdjustment() {
      let dataToSend = {
        billId: this.billId,
        wasManuallyAddedFlag: this.filterModel.adjustmentType?.value,
        adjustmentReasonId: this.filterModel.adjustment?.id,
        objected: this.filterModel.objected?.value,
        objectionStatusId: this.filterModel.status?.id,
        studentSie: this.filterModel.sie,
        contractNumber: this.filterModel.contract,
        pageindex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      };

      this.results = [];
      const { data } = await _getAllAdjustment(dataToSend);
      this.results = data.data;
      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount,
      };
    },
    async getAdjustmentSummary() {
      const { data } = await _getAdjustmentsummary(this.billId);
      if (data) this.adjustmentSummary = data;
    },
    async onSearchHandler() {
      await this.getAllAdjustment();
    },
    async changePageSize(size) {
      this.pagination.pageSize = size;
      await this.getAllAdjustment();
      this.keyResultRow = this.keyResultRow * -1;
    },
    async goToPageHandler(page) {
      this.pagination.pageIndex = page;
      await this.getAllAdjustment();
      this.keyResultRow = this.keyResultRow * -1;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .custom-icon {
  .dot {
    width: 30px !important;
    height: 30px !important;
    .title-icon {
      margin-top: 2px;
      font-size: 15px;
    }
  }
}
</style>
